(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/dialogs/payment-confirm.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/dialogs/payment-confirm.js');
'use strict';

const {
  isPayAfterDeposit,
  uppercaseFirst
} = svs.tur.payment.utils.misc;
class PaymentConfirm extends svs.tur.payment.dialogs.DialogBase {
  constructor(_ref) {
    let {
      productName,
      productNumeric,
      price,
      accountBalance,
      isCancelable = true,
      isNumberGame = true,
      onConfirm,
      onCancel,
      nextDrawDate,
      upcomingDrawProduct
    } = _ref;
    super({
      onConfirm,
      onCancel
    });
    this.productName = productName;
    this.productNumeric = productNumeric;
    this.price = price;
    this.accountBalance = accountBalance;
    this.isCancelable = isCancelable;
    this.isNumberGame = isNumberGame;
    this.nextDrawDate = nextDrawDate;
    this.upcomingDrawProduct = upcomingDrawProduct;
    this.show();
  }
  getTitle() {
    const introText = (isPayAfterDeposit() ? 'Din insättning är klar.<br>' : '') + (this.isNumberGame ? 'Vill du betala ett spel på' : 'Vill du betala en');
    return "".concat(introText, " ").concat(uppercaseFirst(this.productName), "\xA0f\xF6r\xA0").concat(this.price, "\xA0kr?");
  }
  getMessage() {
    return [{
      type: svs.components.dialog.message.TEXT,
      text: this.getCancelableInfo(),
      align: svs.components.dialog.message.align.CENTER
    }, {
      type: svs.components.dialog.message.TEXT,
      text: "".concat(this.getAccountOwner(), " saldo: ").concat(svs.utils.format.Currency(this.accountBalance), " kr"),
      align: svs.components.dialog.message.align.CENTER
    }];
  }
  getActions() {
    return [{
      title: 'Avbryt',
      callback: (e, forms, dialog) => {
        svs.components.analytics.trackEvent({
          category: 'betslip_cancelled',
          action: 'yes',
          opt_label: this.productName
        });
        dialog.close();
        if (this.onCancel) {
          this.onCancel();
        }
      }
    }, {
      title: "Betala ".concat(this.price, " kr"),
      callback: (e, forms, dialog) => {
        dialog.close();
        if (this.onConfirm) {
          this.onConfirm();
        }
      }
    }];
  }
  getCancelableInfo() {
    return this.isCancelable ? 'Spelet går att annullera.' : 'Observera att spelet inte går att annullera';
  }
}
svs.tur.payment.dialogs.PaymentConfirm = PaymentConfirm;

 })(window);